import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { LoadingProps } from "./types";
import "./styles.scss";
export const Loading = ({ allScreen, dataQA, icon, className, text }: LoadingProps) => {
  const renderIcon = () => {
    if (icon) {
      return React.cloneElement(icon, {
        id: `loadingSpinner${allScreen ? "--complete" : ""}`,
      });
    }
    return <AiOutlineLoading3Quarters id={`loadingSpinner${allScreen ? "--complete" : ""}`} />;
  };
  return (
    <div
      data-testid="Loading"
      className={`Loading${allScreen ? "--complete" : ""} ${className ? className : ""}`}
      data-qa={dataQA}>
      {renderIcon()}
      {text}
    </div>
  );
};
export const AILoader = ({ dataQA, color }: { dataQA?: string; color?: string }) => {
  return (
    <span
      className="loader2"
      data-qa={dataQA}
      style={{ borderTopColor: color }}></span>
  );
};
